<div class="row-center">
	<mat-form-field subscriptSizing="dynamic" appearance="outline" class="form-width-size">
		<mat-label i18n="@@verificationCode-label">Verification Code</mat-label>
		<input
			matInput
			#input
			[formControl]="verificationCodeFormControl"
			maxlength="6"
			(ngModelChange)="validateCode(input.value)"
			data-automation-id="verification-code-input"
		/>
		@if (this.verificationCodeFormControl.hasError('pattern')) {
			<mat-error class="row-left" data-automation-id="verification-code-error" i18n="@@verificationCode-errorMessage">
				Invalid code, please try again.
			</mat-error>
		}
	</mat-form-field>
</div>
